import Icon from "./Icon"

const EuroIcon = (props) => (
  <Icon iconName="icon-euro" size={16} {...props}>
    <path d="M10.586 1.002a5.457 5.457 0 0 1 2.862.716.5.5 0 0 1-.496.868 4.472 4.472 0 0 0-2.352-.584c-2.523 0-4.417 1.599-5.086 4H9.5a.5.5 0 0 1 .09.992l-.09.008H5.313a7.873 7.873 0 0 0 0 2H9.5a.5.5 0 0 1 .09.992l-.09.008H5.514c.67 2.401 2.563 4 5.086 4 .825 0 1.637-.203 2.365-.591a.5.5 0 1 1 .47.882 6.035 6.035 0 0 1-2.835.709c-3.1 0-5.405-2.043-6.119-5H2.5a.5.5 0 0 1-.09-.992l.09-.008h1.806a8.884 8.884 0 0 1 0-2H2.5a.5.5 0 0 1-.09-.992l.09-.008h1.981c.713-2.957 3.016-5 6.105-5Z"></path>
  </Icon>
)

export default EuroIcon
